import * as actionTypes from './actionTypes';
import * as actions from './index';
import * as Metadata from 'Flow2/containers/Masterdata/Masterdata';
import { checkLogOutForApp, isPMDB } from 'Flow2/components/CustomCollections/CustomDataControllers/CustomAppController.js';

export const authStart = () => {
    return {
        type: actionTypes.AUTH_START
    };
};

export const authSuccess = (user) => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        user: user
    };
};

export const authFail = (error) => {
    return {
        type: actionTypes.AUTH_FAIL,
        error: error
    };
};

export const logout = (logout = false, manual = false) => {
    localStorage.removeItem('expirationDate');
    localStorage.removeItem('user');

    if (manual) {
        return manualLogout();
    }
    return {
        type: actionTypes.AUTH_LOGOUT,
        logout: logout
    };
};

const manualLogout = () => {
    return (dispatch) => {
        dispatch({ type: actionTypes.AUTH_LOGOUT_START });
        window.flow.logout().then((res) => {
            dispatch({ type: actionTypes.AUTH_LOGOUT_SUCCESS });
            window.location.reload();
        }).catch(res => {
            dispatch({ type: actionTypes.AUTH_LOGOUT_FAIL });
        });
    };
};

export const checkAuthTimeout = (expirationTime) => {
    return dispatch => {
        setTimeout(() => {
            dispatch(logout());
        }, expirationTime * 1000);
    };
};

const authResSuccess = (dispatch, res) => {
    console.log(res.user);
    if (!res.user.g.udo.flow2login) {
        window.flow.logout().then((res) => {
            dispatch({ type: actionTypes.AUTH_NO_LOGIN });
        })
    } else {
        dispatch(authSuccess(res.user));

        if (res.user.g.udo.standardview === '' || !res.user.g.udo.standardview || res.user.g.udo.standardview === undefined) {
            dispatch(actions.setClipListViewMode('grid'));
        } else {
            dispatch(actions.setClipListViewMode(res.user.g.udo.standardview));
        }

        if (res.user.g.udo.uilanguage) {
            /*if (isPMDB()) dispatch(actions.selectLanguage(res.user.g.udo.uilanguage));
            else dispatch(actions.selectLanguage(res.user.g.udo.uilanguage.substr(0, 2)));*/
            dispatch(actions.selectLanguage(res.user.g.udo.uilanguage.substr(0, 2)));
        }

        setMetadataConfig(dispatch, res.user);
        dispatch(actions.loadSoapApiDef());
    }
}

export const auth = (user, password, isSignup, formatMessage) => {
    return (dispatch, getState) => {
        dispatch(authStart());

        window.flow.login(user, password).then((res) => {
            if (res.success) {
                authResSuccess(dispatch, res);

                //check if event = LOGOUT
                checkLogOutForApp(getState().auth.error, formatMessage);

                dispatch(actions.initLimitModule(getState().app.modules.modules));

                // EXTRACTED BY IMPLEMENT sessionLogin
                /*
                dispatch(authSuccess(res.user));

                if (res.user.g.udo.standardview === '' || !res.user.g.udo.standardview || res.user.g.udo.standardview === undefined) {
                    dispatch(actions.setClipListViewMode('grid'));
                } else {
                    dispatch(actions.setClipListViewMode(res.user.g.udo.standardview));
                }

                if (res.user.g.udo.uilanguage) {
                    dispatch(actions.selectLanguage(res.user.g.udo.uilanguage.substr(0, 2)));
                }

                setMetadataConfig(dispatch, res.user);
                dispatch(actions.loadSoapApiDef());
                */

                /*
                // set metadata config
                import(`${process.env.REACT_APP_APPID}/config/metadata_clip.json`).then(module => {
                console.log(module);
                let config = {};
                config.clip = module.default;
                
                dispatch({type: actionTypes.LOAD_METADATA_CONFIG_SUCCESS, config: config });
                dispatch( actions.loadSoapApiDef() );
                }).catch((error) => {
                    console.log("JSON IMPORT ERROR");
                    
                });
                */
                //
            }
        }).catch(res => {
            dispatch(authFail(res.msg));
        });
    };
};

const setMetadataConfig = (dispatch, user) => {
    let config = {};

    if (user.g.udo.metadata_clip) {
        config[Metadata.OBJECT_TYPE_CLIP] = JSON.parse(user.g.udo.metadata_clip);
    }

    if (user.g.udo.metadata_project) {
        config[Metadata.OBJECT_TYPE_PROJECT] = JSON.parse(user.g.udo.metadata_project);
    }

    dispatch({ type: actionTypes.LOAD_METADATA_CONFIG_SUCCESS, config: config });
}

export const setAuthRedirectPath = (path) => {
    return {
        type: actionTypes.SET_AUTH_REDIRECT_PATH,
        path: path
    };
};

export const authCheckState = () => {
    return dispatch => {

        //const user = JSON.parse(localStorage.getItem('user'));
        const user = undefined;
        if (typeof (user) === 'undefined' || typeof (window.flow) === 'undefined') {
            dispatch(logout());
        } else {

            dispatch(authSuccess(user));
            //dispatch(checkAuthTimeout((expirationDate.getTime() - new Date().getTime()) / 1000 ));

        }
    };
};

export const switchGroup = (user, groupid) => {
    return (dispatch) => {
        if (user.groupid != groupid) {
            dispatch({ type: actionTypes.AUTH_SWITCH_GROUP_START });
            window.flow.switchUsergroup(groupid).then((res) => {
                dispatch({ type: actionTypes.AUTH_SWITCH_GROUP_SUCCESS });
                window.location.reload();
            }).catch(res => {
                dispatch({ type: actionTypes.AUTH_SWITCH_GROUP_FAIL });
            });
        } else {
            dispatch({ type: actionTypes.AUTH_SWITCH_GROUP_FAIL });
        }
    };
};

export const sessionLogin = () => {
    return (dispatch) => {
        dispatch({ type: actionTypes.AUTH_SESSION_LOGIN_START });
        window.flow.sessionLogin().then((res) => {
            if (res.success) {
                authResSuccess(dispatch, res);
                dispatch({ type: actionTypes.AUTH_SESSION_LOGIN_SUCCESS });
            } else {
                dispatch({ type: actionTypes.AUTH_SESSION_LOGIN_FAIL });
            }
        }).catch(res => {
            dispatch({ type: actionTypes.AUTH_SESSION_LOGIN_FAIL });
        });
    };
};
